// extracted by mini-css-extract-plugin
export var actions = "_lg-g";
export var benefitCard = "_lg-b";
export var benefitIcon = "_lg-d";
export var benefitLabel = "_lg-f";
export var benefits = "_lg-a";
export var benefitsSection = "_lg-8";
export var bodyText = "_lg-7";
export var closeButton = "_lg-2";
export var content = "_lg-3";
export var eyebrow = "_lg-4";
export var heading = "_lg-5";
export var image = "_lg-i";
export var imagePanel = "_lg-h";
export var modal = "_lg-0";
export var offerCard = "_lg-c";
export var offerIcon = "_lg-e";
export var sectionLabel = "_lg-9";
export var shell = "_lg-1";
export var title = "_lg-6";